<template>
  <v-card flat>
    <b-row>
      <b-col :md="6">
        <b-form-group
          id="item-invoice-number-group"
          :label="$t('FORM_LABELS.INVOICE_NUMBER')"
          label-for="item-invoice-number-input"
        >
          <FormInput
            id="item-invoice-number-input"
            type="text"
            v-model="form.invoiceNumber"
            :validateState="validateState('invoiceNumber')"
          ></FormInput>
        </b-form-group>
      </b-col>
      <b-col :md="6">
        <b-form-group
          id="item-date-group"
          :label="$t('FORM_LABELS.DATE')"
          label-for="item-date-input"
        >
          <FormDatepicker
            id="item-date-input"
            v-model="form.date"
            :validateState="validateState('date')"
          ></FormDatepicker>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col :md="6">
        <b-form-group
          id="item-invoice-type-group"
          :label="$t('FORM_LABELS.TYPE')"
          label-for="item-invoice-type-input"
        >
          <FormSelect
            id="item-invoice-type-input"
            clearable
            :options="invoiceTypeOptions"
            v-model="form.aiInvoiceTypeId"
            :validateState="validateState('aiInvoiceTypeId')"
          ></FormSelect>
        </b-form-group>
      </b-col>
      <b-col :md="6">
        <b-form-group
          id="item-currency-group"
          :label="$t('FORM_LABELS.CURRENCY')"
          label-for="item-currency-input"
        >
          <FormSelect
            id="item-currency-input"
            clearable
            :options="currencyOptions"
            v-model="form.currency"
            reduceKey="value"
          ></FormSelect>
        </b-form-group>
      </b-col>
    </b-row>

    <h5 class="mt-5 mb-3">{{ $t("FORM_LABELS.SUPPLIER") }}</h5>
    <b-row>
      <b-col :md="6">
        <b-form-group
          id="item-ai-supplier-group"
          :label="$t('FORM_LABELS.AI_COMPANY')"
          label-for="item-ai-supplier-input"
        >
          <FormSelect
            id="item-ai-supplier-input"
            clearable
            :options="supplierOptions"
            v-model="form.aiSupplierId"
            :validateState="validateState('aiSupplierId')"
            @input="onSupplierSelect"
          ></FormSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col :md="6">
        <b-form-group
          id="item-supplier-name-group"
          :label="$t('FORM_LABELS.NAME')"
          label-for="item-supplier-name-input"
        >
          <FormInput
            id="item-supplier-name-input"
            type="text"
            v-model="form.supplierName"
            :validateState="validateState('supplierName')"
          ></FormInput>
        </b-form-group>
      </b-col>
      <b-col :md="6">
        <b-form-group
          id="item-supplier-vat-group"
          :label="$t('FORM_LABELS.VAT')"
          label-for="item-supplier-vat-input"
        >
          <FormInput
            id="item-supplier-vat-input"
            type="text"
            v-model="form.supplierVat"
            :validateState="validateState('supplierVat')"
          ></FormInput>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col :md="6">
        <b-form-group
          id="item-supplier-mol-group"
          :label="$t('FORM_LABELS.MOL')"
          label-for="item-supplier-mol-input"
        >
          <FormInput
            id="item-supplier-mol-input"
            type="text"
            v-model="form.supplierMol"
            :validateState="validateState('supplierMol')"
          ></FormInput>
        </b-form-group>
      </b-col>
      <b-col :md="6">
        <b-form-group
          id="item-supplier-address-group"
          :label="$t('FORM_LABELS.ADDRESS')"
          label-for="item-supplier-address-input"
        >
          <FormInput
            id="item-supplier-address-input"
            type="text"
            v-model="form.supplierAddress"
            :validateState="validateState('supplierAddress')"
          ></FormInput>
        </b-form-group>
      </b-col>
    </b-row>

    <h5 class="mt-5 mb-3">{{ $t("FORM_LABELS.BUYER") }}</h5>
    <b-row>
      <b-col :md="6">
        <b-form-group
          id="item-ai-buyer-group"
          :label="$t('FORM_LABELS.AI_COMPANY')"
          label-for="item-ai-buyer-input"
        >
          <FormSelect
            id="item-ai-buyer-input"
            clearable
            :options="buyerOptions"
            v-model="form.aiBuyerId"
            :validateState="validateState('aiBuyerId')"
            @input="onBuyerSelect"
          ></FormSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col :md="6">
        <b-form-group
          id="item-buyer-name-group"
          :label="$t('FORM_LABELS.NAME')"
          label-for="item-buyer-name-input"
        >
          <FormInput
            id="item-buyer-name-input"
            type="text"
            v-model="form.buyerName"
            :validateState="validateState('buyerName')"
          ></FormInput>
        </b-form-group>
      </b-col>
      <b-col :md="6">
        <b-form-group
          id="item-buyer-vat-group"
          :label="$t('FORM_LABELS.VAT')"
          label-for="item-buyer-vat-input"
        >
          <FormInput
            id="item-buyer-vat-input"
            type="text"
            v-model="form.buyerVat"
            :validateState="validateState('buyerVat')"
          ></FormInput>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col :md="6">
        <b-form-group
          id="item-buyer-mol-group"
          :label="$t('FORM_LABELS.MOL')"
          label-for="item-buyer-mol-input"
        >
          <FormInput
            id="item-buyer-mol-input"
            type="text"
            v-model="form.buyerMol"
            :validateState="validateState('buyerMol')"
          ></FormInput>
        </b-form-group>
      </b-col>
      <b-col :md="6">
        <b-form-group
          id="item-buyer-address-group"
          :label="$t('FORM_LABELS.ADDRESS')"
          label-for="item-buyer-address-input"
        >
          <FormInput
            id="item-buyer-address-input"
            type="text"
            v-model="form.buyerAddress"
            :validateState="validateState('buyerAddress')"
          ></FormInput>
        </b-form-group>
      </b-col>
    </b-row>

    <h5 class="mt-5 mb-3">{{ $t("FORM_LABELS.AMOUNTS") }}</h5>
    <b-row>
      <b-col :md="4">
        <b-form-group
          id="item-total-amount-group"
          :label="$t('FORM_LABELS.TOTAL_AMOUNT')"
          label-for="item-total-amount-input"
        >
          <FormInput
            id="item-total-amount-input"
            type="number"
            step="0.01"
            v-model="form.totalAmount"
            :validateState="validateState('totalAmount')"
          ></FormInput>
        </b-form-group>
      </b-col>
      <b-col :md="4">
        <b-form-group
          id="item-tax-amount-group"
          :label="$t('FORM_LABELS.TAX_AMOUNT')"
          label-for="item-tax-amount-input"
        >
          <FormInput
            id="item-tax-amount-input"
            type="number"
            step="0.01"
            v-model="form.taxAmount"
            :validateState="validateState('taxAmount')"
          ></FormInput>
        </b-form-group>
      </b-col>
      <b-col :md="4">
        <b-form-group
          id="item-payment-deadline-group"
          :label="$t('FORM_LABELS.PAYMENT_DEADLINE')"
          label-for="item-payment-deadline-input"
        >
          <FormDatepicker
            id="item-payment-deadline-input"
            v-model="form.paymentDeadlineDate"
            :validateState="validateState('paymentDeadlineDate')"
          ></FormDatepicker>
        </b-form-group>
      </b-col>
    </b-row>
  </v-card>
</template>

<script>
import { FETCH_AI_INVOICE_TYPES } from "@/modules/ai-invoices/store/ai-invoices.module";
import { FETCH_AI_COMPANY_OPTIONS } from "@/modules/ai-companies/store/ai-companies.module";

import FormInput from "@/view/content/forms/components/FormInput.vue";
import FormDatepicker from "@/view/content/forms/components/FormDatepicker.vue";
import FormSelect from "@/view/content/forms/components/FormSelect";
import FormSwitch from "@/view/content/forms/components/FormSwitch";

import { validationMixin } from "vuelidate";
import { formBuilderMixin } from "@/core/mixins/formBuilderMixin.js";

export default {
  mixins: [validationMixin, formBuilderMixin],
  components: {
    FormSelect,
    FormInput,
    FormSwitch,
    FormDatepicker
  },
  props: {
    form: Object
  },
  validations() {
    return {
      form: {
        invoiceNumber: this.setItemValidations({
          required: true
        }),
        date: this.setItemValidations({
          required: true
        }),
        currency: this.setItemValidations({
          required: true
        }),
        totalAmount: this.setItemValidations({
          required: true,
          numeric: true
        }),
        taxAmount: this.setItemValidations({
          required: true,
          numeric: true
        }),
        supplierName: {},
        supplierVat: {},
        supplierMol: {},
        supplierAddress: {},
        buyerName: {},
        buyerVat: {},
        buyerMol: {},
        buyerAddress: {},
        paymentDeadlineDate: {},
        aiSupplierId: {},
        aiBuyerId: {},
        aiInvoiceTypeId: {}
      }
    };
  },
  data() {
    return {
      invoiceTypeOptions: [],
      supplierOptions: [],
      buyerOptions: [],
      currencyOptions: [
        { id: "BGN", name: "BGN", value: "BGN" },
        { id: "EUR", name: "EUR", value: "EUR" },
        { id: "USD", name: "USD", value: "USD" },
        { id: "GBP", name: "GBP", value: "GBP" }
      ]
    };
  },
  mounted() {
    this.fetchInvoiceTypes();
    this.fetchSuppliers();
    this.fetchBuyers();
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async fetchInvoiceTypes() {
      try {
        const data = await this.$store.dispatch(FETCH_AI_INVOICE_TYPES);
        this.invoiceTypeOptions = data.data;
      } catch (error) {
        console.error("Error fetching invoice types:", error);
      }
    },
    async fetchSuppliers() {
      try {
        const data = await this.$store.dispatch(
          FETCH_AI_COMPANY_OPTIONS,
          "?type=supplier"
        );
        this.supplierOptions = data;
      } catch (error) {
        console.error("Error fetching suppliers:", error);
      }
    },
    async fetchBuyers() {
      try {
        const data = await this.$store.dispatch(
          FETCH_AI_COMPANY_OPTIONS,
          "?type=buyer"
        );
        this.buyerOptions = data;
      } catch (error) {
        console.error("Error fetching buyers:", error);
      }
    },
    onSupplierSelect(supplierId) {
      if (!supplierId) {
        this.form.supplierName = null;
        this.form.supplierVat = null;
        this.form.supplierMol = null;
        this.form.supplierAddress = null;
        return;
      }

      const selectedSupplier = this.supplierOptions.find(
        supplier => supplier.id === supplierId
      );

      if (selectedSupplier) {
        this.form.supplierName = selectedSupplier.name || null;
        this.form.supplierVat = selectedSupplier.vatNumber || null;
        this.form.supplierMol = selectedSupplier.molNumber || null;
        this.form.supplierAddress = selectedSupplier.address || null;
      }
    },
    onBuyerSelect(buyerId) {
      if (!buyerId) {
        this.form.buyerName = null;
        this.form.buyerVat = null;
        this.form.buyerMol = null;
        this.form.buyerAddress = null;
        return;
      }

      const selectedBuyer = this.buyerOptions.find(
        buyer => buyer.id === buyerId
      );

      if (selectedBuyer) {
        this.form.buyerName = selectedBuyer.name || null;
        this.form.buyerVat = selectedBuyer.vatNumber || null;
        this.form.buyerMol = selectedBuyer.molNumber || null;
        this.form.buyerAddress = selectedBuyer.address || null;
      }
    }
  }
};
</script>

<style scoped>
.v-card {
  padding: 20px;
}
</style>
